import { PublicClientApplication, LogLevel } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: '8d22d5e6-98a8-4fd0-bc55-22d2cbf7cae5',
    authority: 'https://SkydriveCustomers.ciamlogin.com/8a773c93-532b-497a-9891-e40748a66e31',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false, // Prevents browser prompt asking to access other apps/services
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

// Create and export msalInstance
export const msalInstance = new PublicClientApplication(msalConfig);
